import React from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { adminAPI } from '../../../api';

import useModal from '../../../context/ModalContext';
import useAlarm from '../../../context/AlarmContext';
import FormLoader from '../../../components/FormLoader';

const ResendConfirmationModal = ({
  items,
  setItems,
  checkedAllUsers,
  totalUsers,
  filter,
  searchQuery,
  handleSelectAllUsers,
}) => {
  const { setAlarm } = useAlarm();
  const { setContent, closeModal } = useModal();

  const queryClient = useQueryClient();

  const { mutate, isLoading: mutationIsLoading } = useMutation(
    adminAPI.resendConfirmation,
    {
      onSuccess: (data) => {
        setAlarm({ type: 'success', message: data.message });
        setContent({ title: null, body: null });
        setItems([]);
        handleSelectAllUsers(false);
        queryClient.invalidateQueries('allUsers');
        closeModal();
      },
      onSettled: (data, error) => {
        if (error) {
          setAlarm({ type: 'error', message: error.message });
          closeModal();
        }
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    let dataToSend;

    if (checkedAllUsers === true) {
      dataToSend = {
        selectAll: true,
        searchQuery: searchQuery,
        filter: filter,
        queryListId: 'unconfirmedUsers',
      };
    } else {
      dataToSend = items.map((item) => ({ id: item.id }));
    }

    mutate(JSON.stringify(dataToSend));
  };

  const count = checkedAllUsers ? totalUsers : items?.length || 0;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h2 className="font-semibold">Resend confirmation email</h2>
        {checkedAllUsers ? (
          <p>
            You are resending confirmation emails to all{' '}
            {totalUsers.toLocaleString('en-US')} unconfirmed users.
          </p>
        ) : (
          <>
            <p>You are resending confirmation emails to the following users.</p>
            <div
              style={{ maxHeight: '400px' }}
              className="border-2 border-gray rounded-2lg p-4 overflow-y-scroll my-8"
            >
              {items.map((item) => (
                <p key={item.id}>{item.email}</p>
              ))}
            </div>
          </>
        )}

        <button
          type="submit"
          className="font-semibold p-4 rounded-lg bg-green-light text-white mt-4"
        >
          Resend confirmation email to {count.toLocaleString('en-US')} user
          {count === 1 ? '' : 's'}
        </button>
      </form>
      {mutationIsLoading && <FormLoader />}
    </>
  );
};

export default ResendConfirmationModal;
